import React, { useContext } from "react";
import { Alert } from "@cmsgov/ds-medicare-gov";
import { FormattedMessage } from "react-intl-phraseapp";
import URI from "urijs";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useTranslate } from "../helpers/intlHooks";
import { AppStore } from "../app/store";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import routes from "../app/routes";
import { sendTealiumEvent } from "../helpers";

const YearSwitchBanner: React.FunctionComponent<RouteComponentProps> = ({
  location,
}) => {
  const t = useTranslate();
  const { mctCurrentPlanYear } = useFlags();
  const { state } = useContext(AppStore.AppContext);
  const pathName = location.pathname;

  const showBanner = [
    routes.beneLanding,
    routes.drugSearchPreferences,
    routes.managePrescriptions,
    routes.pdePage,
    routes.pharmacy,
    routes.prescriptionsList,
    routes.questionRouting,
    routes.sanctionedPlans,
    routes.searchResults,
  ].includes(pathName);

  const isCurrentYear = state.year === mctCurrentPlanYear.toString();
  const otherYear = isCurrentYear ? mctCurrentPlanYear + 1 : mctCurrentPlanYear;

  const switchYearRoute = new URI(location.search);
  switchYearRoute.removeSearch("year");
  switchYearRoute.addSearch({ year: otherYear });

  return showBanner ? (
    <Alert role="alert" className="previewBanner mct-hide-print">
      <span>
        <FormattedMessage
          id="public_preview.viewing_year_plans"
          values={{ year: state.year }}
        />
        {isCurrentYear
          ? t("public_preview.enroll_current_year")
          : t("public_preview.enroll_next_year")}{" "}
        <Link
          to={switchYearRoute.valueOf()}
          onClick={(): void => {
            sendTealiumEvent(
              `Find Plans - ${state.year}`,
              `Show me ${otherYear} plans`
            );
          }}
        >
          <FormattedMessage
            id="public_preview.show_me_year_plans"
            values={{ year: otherYear }}
          />
        </Link>
      </span>
    </Alert>
  ) : null;
};

export default withRouter(YearSwitchBanner);
